export const SocialMediaPlatform = {
    FACEBOOK: "Facebook",
    INSTAGRAM: "Instagram",
    LINKEDIN: "LinkedIn",
};

export const SocialMediaPlatformColors = {
    FACEBOOK: "#1877F2",
    INSTAGRAM: "#EE1C8E",
    LINKEDIN: "#0A69C5",
};

export const InstagramResponseURL = "/noticeboard";
export const InstagramScopes = "instagram_business_content_publish,instagram_business_basic";

/**
 * Scopes to request from the user.
 * Note these MUST be available for us to use, or else we'll get a vague "Bummer" message when trying to get access.
 * See the developer portal for the app under "Auth" -> "OAuth 2.0 scopes"
 */
export const LinkedInScopes = "r_basicprofile w_member_social w_organization_social rw_organization_admin";

export const LinkedInResponseURL = "noticeboard?connectType=linkedin";
